export default function Splash() {
  return (
    <div className="w-screen h-screen flex justify-center items-center p-5">
      <img src="/logo192.png" alt="logo" className="max-w-[60%] motion-safe:animate-ping" role="status" />
    </div>
  );
}
